var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Overview") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Overview",
    stroke: "#B5B5B5",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,3.95 C13.1097408,3.95 14.0093634,4.84962265 14.0093634,5.95936342 L14.0093634,5.95936342 L18.0453183,5.95936342 C18.597603,5.95936342 19.0453183,6.40707867 19.0453183,6.95936342 L19.0453183,19.05 C19.0453183,19.6022847 18.597603,20.05 18.0453183,20.05 L5.95468171,20.05 C5.40239696,20.05 4.95468171,19.6022847 4.95468171,19.05 L4.95468171,6.95936342 C4.95468171,6.40707867 5.40239696,5.95936342 5.95468171,5.95936342 L9.99063658,5.95936342 C9.99063658,4.84962265 10.8902592,3.95 12,3.95 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.88026428,
    y1: 9.54521893,
    x2: 15.1197357,
    y2: 9.54521893,
    id: "Path-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.88026428,
    y1: 12.8132703,
    x2: 15.1197357,
    y2: 12.8132703,
    id: "Path-5-Copy-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.88026428,
    y1: 16.0813217,
    x2: 15.1197357,
    y2: 16.0813217,
    id: "Path-5-Copy"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/Overview.5a7c3826.svg";
export { ForwardRef as ReactComponent };